import { observeElement } from "./observeElement";

export function inputBank() {
    const inputBankname = document.querySelector<HTMLFormElement>("#bank_name");
    if (inputBankname) {
        const visibleInputBank =
            document.querySelector<HTMLFormElement>("#bank");
        observeElement(
            inputBankname,
            "value",
            (oldValue: string, newValue: string) => {
                if (visibleInputBank) {
                    visibleInputBank.value = newValue;
                }
            },
        );
    }

    const ibanfield = document.querySelector<HTMLFormElement>("#iban");
    if (ibanfield) {
        ibanfield.addEventListener("change", (event) => {
            event.preventDefault();
            const target = event.target as HTMLFormElement;
            let iban = target.value;

            if (iban != null) {
                iban = iban.replace(/ /g, "");
                iban = iban.toUpperCase();
                ibanfield.value = iban;

                const data = new FormData();
                data.append("iban", iban);

                const api_url = "/order/api_getbank_iban";

                const settings: RequestInit = {
                    method: "POST",
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                    body: data,
                    cache: "default",
                    credentials: "same-origin",
                };

                if (iban != "") {
                    fetch(api_url, settings)
                        .then((response) => {
                            return response.json();
                        })
                        .then((data) => {
                            if (typeof data["bankname"] != "undefined") {
                                const bankName =
                                    document.querySelector<HTMLFormElement>(
                                        "#bank_name",
                                    );
                                if (bankName) {
                                    bankName.value = data["bankname"];
                                }
                            }
                            if (typeof data["bic"] != "undefined") {
                                const bic =
                                    document.querySelector<HTMLFormElement>(
                                        "#bic",
                                    );
                                if (bic) {
                                    bic.value = data["bic"];
                                }
                            }
                        });
                }
            }
        });
    }
}
